<template>
  <div class="con" v-loading="loading">
    <div>
      <el-tabs v-model="activeName">
        <el-tab-pane :label="`${$t('lang.smartlink.general')}`" name="default">
          <div class="text item">
            <!-- 模式配置 -->
            <p style="line-height: 1;font-size: 16px;padding-bottom: 10px;">{{ $t('lang.smartlink.modeConfiguration') }}
            </p>
            <el-table :data="data.mode" border strip>
              <el-table-column :label="`${$t('lang.smartlink.enable')}`">
                <template slot-scope="scope">
                  <span>{{ scope.row.enabled == '1' ? '✔' : '✖' }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.uplink')}`" prop="uplink">
                <template slot-scope="scope">
                  <span>{{ (scope.row.uplink).join(',') }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.downlink')}`" prop="downlink"></el-table-column>
              <el-table-column :label="`${$t('lang.Button.operation')}`">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click="modeEdit(scope.row, scope.$index)">{{
                    $t('lang.Button.edit') }}</el-button>
                  <el-button type="danger" size="small" :disabled="noSname === false ? false : true"
                    @click="modeDelete(scope.row, scope.$index)">{{ $t('lang.Button.delete') }}</el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button :disabled="noSname === false ? false : true" class="add-button" type="primary" size="small"
              @click="modeAdd()">{{ $t('lang.Button.Add') }}</el-button>
            <!-- 连接配置 -->
            <p style="line-height: 1;font-size: 16px;padding-bottom: 10px;margin-top: 10px;">
              {{ $t('lang.smartlink.connectConfiguraton') }}</p>
            <conn :Conn="data.Conn" @updateData="updateData" :deviceDid="deviceDid" :deviceSn="deviceSn" :com='data.COM'
              :noSname="noSname" :vendorName="vendorName" :deviceSoftwareVer="deviceSoftwareVer"></conn>
            <!--串口配置-->
            <p style="line-height: 1;font-size: 16px;padding-bottom: 10px;margin-top: 10px;">
              {{ $t('lang.smartlink.serialPort') }}</p>
            <el-table :data="data.COM" border strip>
              <el-table-column :label="`${$t('lang.smartlink.interface')}`" prop="section"></el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.baudRate')}`" prop="baudrate"></el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.dataBits')}`" prop="data_bits"></el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.stopBits')}`" prop="stop_bits"></el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.checkBits')}`">
                <template slot-scope="scope">
                  <span>{{ GetCOM1Parity(scope.row.parity) }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="`${$t('lang.smartlink.flowControl')}`">
                <template slot-scope="scope">
                  <span>{{ scope.row.flow_ctrl == 'N' ? 'None' : 'XON/XOFF' }}</span>
                </template>
              </el-table-column>
              <el-table-column :label="`${$t('lang.Button.operation')}`">
                <template slot-scope="scope">
                  <el-button type="primary" size="small" @click="comEdit(scope.row, scope.$index)">
                    {{ $t('lang.Button.edit') }}
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <el-button type="primary" size="mini" style="margin: 10px auto;display: flex;align-items: center;"
              @click="saveTap">保存并应用</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane :label="$t('lang.smartlink.collection')" name="collection">
          <collection ref="collection" :deviceDid="deviceDid" :deviceSn="deviceSn"></collection>
        </el-tab-pane>
        <el-tab-pane :label="`${$t('lang.smartlink.senior')}`" name="senior">
          <senior :originalServer="originalServer" :data="data.service" v-if="data.service" :deviceDid="deviceDid"
            :deviceSn="deviceSn" @updateData="updateData"></senior>
        </el-tab-pane>
      </el-tabs>
      <!-- <div v-else style="height: 200px; color: red; font-weight: bold; font-size: 20px; text-align: center;margin-top: 100px">
        <span v-if="!loading">该设备版本不支持</span>
      </div> -->
    </div>
    <!-- 模式配置修改/添加框 -->
    <mode-dialog ref="modeDialog" :deviceDid="deviceDid" :deviceSn="deviceSn" @updateData="updateData"
      :linkOptions="linkOptions" :noSname="noSname"></mode-dialog>
    <!-- 串口配置修改/添加 -->
    <com-dialog ref="comDialog" :deviceDid="deviceDid" :deviceSn="deviceSn" @updateData="updateData"></com-dialog>
  </div>
</template>

<script>
import { updateConfig } from "@/api/configurationlist";
import { progressControl } from "@/api/particulars";
import conn from "./components/Conn/index";
import senior from "./components/Senior/index";
import modeDialog from "./components/Mode/contDialog";
import collection from "./components/collection"
import comDialog from "./components/Com/contDialog";
import { cloneDeep } from 'lodash'
export default {
  name: "SmartLink",
  props: ["deviceDid", "deviceSn", "data", "linkOptions", "loading",
    'originalServer', 'noSname', 'vendorName', 'deviceSoftwareVer'],
  data() {
    return {
      // tabs标志
      activeName: "default",
      // 原始高级配置
    };
  },
  watch: {
    deviceSn: {
      handler: function (val) {

      }
    },
    loading:{
      handler(){
        this.$refs.collection.getData()
      }
    }
  },
  methods: {
    //串口配置-校验位
    GetCOM1Parity(type) {
      switch (type) {
        case "S": {
          return "Space";
        }
        case "E": {
          return "Even";
        }
        case "M": {
          return "Mask";
        }
        case "O": {
          return "Odd";
        }
        case "N": {
          return "None";
        }
        default:
          return type;
      }
    },
    // 修改模式配置
    modeEdit(row, index) {
      this.$refs.modeDialog.show(row, index);
    },
    // 添加模式配置
    modeAdd() {
      this.$refs.modeDialog.show("", this.data.mode.length + 1);
    },
    // 删除模式配置
    modeDelete(row, index) {
      this.$confirm(this.$t('lang.Button.isDelete'), this.$t('lang.Button.tips'), {
        confirmButtonText: this.$t('lang.Button.submit'),
        cancelButtonText: this.$t('lang.Button.cancel')
      }).then(() => {
        updateConfig(this.deviceSn, this.deviceDid, [
          {
            section: "mode",
            config: "smartlink",
            action: 2,
            index: [index],
            // server: "smartlink",
            options: {
              enabled: row.enabled
            },
            lists: {
              uplink: row.uplink,
              downlink: row.downlink
            }
          }
        ]).then(res => {
          if (res.data.data.mess == 0) {
            this.$message.success(this.$t('lang.Button.successDelete'));
            this.updateData();
          } else {
            this.$message.error(this.$t('lang.Button.failDelete'));
          }
        });
      });
    },
    // 修改串口配置
    comEdit(row, index) {
      this.$refs.comDialog.show(row, index);
    },
    // 更新数据
    updateData() {
      this.$emit("GetConfig", { name: "智慧物联" });
    },
    async saveTap() {
      this.loading = true
      await progressControl([
        {
          process: 'smartlink',
          type: 0,
          action: 'restart'
        }
      ], this.deviceDid, this.deviceSn)
      this.loading = false
    }
  },
  components: {
    conn,
    senior,
    modeDialog,
    comDialog,
    collection
  },
  created() {
  }
};
</script>

<style scoped>
.add-button {
  margin-top: 10px;
  margin-bottom: 30px;
}
</style>
<style src='../common.css' scoped></style>